import FAIcon from './fa-icon'
import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'

const GradientedScroller = (props) => {
  const [state, setState] = useState({ scrolledToEnd: true, scrolledToStart: true })
  const containerRef = useRef()

  useEffect(() => {
    window.addEventListener("resize", updateScrollState)
    updateScrollState()

    return () => {
      window.removeEventListener("resize", updateScrollState)
    }
  }, [])

  useEffect(() => {
    updateScrollState()
  })

  const scroll = reverse => {
    let container = containerRef.current
    container.scrollBy({ left: reverse * container.clientWidth * .66, behavior: 'smooth' })
  }

  const updateScrollState = () => {
    let container = containerRef.current
    if (container) {
      let scrolledToEnd = container.scrollLeft + container.clientWidth + 50 > container.scrollWidth
      let scrolledToStart = container.scrollLeft == 0
      if (scrolledToEnd != state.scrolledToEnd || scrolledToStart != state.scrolledToStart)
        setState({ scrolledToStart, scrolledToEnd })
    }
  }

  let { children, containerClassName } = props
  let { scrolledToEnd, scrolledToStart } = state
  let classes = classNames('gradiented-scroller', {
    'scrolled-to-end': scrolledToEnd,
    'scrolled-to-start': scrolledToStart,
  })

  return (
    <div className={classes}>
      <button className="feed-scroll-btn btn left" onClick={() => scroll(-1)} aria-label="Scroll left">
        <FAIcon icon='faAngleLeft' />
      </button>
      <div className="feed-gradient left"></div>
      <div className={`gradiented-scroller-inner ${containerClassName}`} ref={containerRef} onScroll={updateScrollState}>
        { children }
      </div>
      <button className="feed-scroll-btn btn right" onClick={() => scroll(1)} aria-label="Scroll right">
        <FAIcon icon='faAngleRight' />
      </button>
      <div className="feed-gradient right"></div>
    </div>
  )
}

GradientedScroller.propTypes = {
  children: PropTypes.array
}

export default GradientedScroller
